import React, {useEffect} from "react";
import ContactForm from "../components/contactForm";
import "./pages.css"
import "./contact.css"

import AOS from "aos"
import "aos/dist/aos.css"

const Contact = () => {
    useEffect(()=>{
        AOS.init({duration: 1000, easing:"ease-in-out"});
    }, []);
    return(
        <div>
            <section className={"allInfo"}>
                <h1 className={"mainTitle contactTitle"}>contact me.</h1>
                <ContactForm></ContactForm>
            </section>
        </div>
    )
}

export default Contact;